export default "__VITE_ASSET__31ba681d__"